export default {
    "name": "UpdateUserTripPreferences",
    "kind": "HoudiniMutation",
    "hash": "bf1d62d211ebbaaeb8d3ad2e534f692f937671f6537522793b2701b0752e13ef",

    "raw": `mutation UpdateUserTripPreferences($input: UpdateUserTripPreferencesInput!) {
  updateUserTripPreferences(input: $input) {
    profile
    name
    email
    carId
    tripPreferences {
      tripConstraint
      distanceSystem
      currency
    }
  }
}`,

    "rootType": "Mutation",
    "stripVariables": [],

    "selection": {
        "fields": {
            "updateUserTripPreferences": {
                "type": "User",
                "keyRaw": "updateUserTripPreferences(input: $input)",

                "selection": {
                    "fields": {
                        "profile": {
                            "type": "String",
                            "keyRaw": "profile",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "nullable": true,
                            "visible": true
                        },

                        "email": {
                            "type": "String",
                            "keyRaw": "email",
                            "visible": true
                        },

                        "carId": {
                            "type": "String",
                            "keyRaw": "carId",
                            "nullable": true,
                            "visible": true
                        },

                        "tripPreferences": {
                            "type": "UserTripPreferences",
                            "keyRaw": "tripPreferences",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "tripConstraint": {
                                        "type": "ItineraryConstraint",
                                        "keyRaw": "tripConstraint",
                                        "visible": true
                                    },

                                    "distanceSystem": {
                                        "type": "DistanceSystem",
                                        "keyRaw": "distanceSystem",
                                        "visible": true
                                    },

                                    "currency": {
                                        "type": "Currency",
                                        "keyRaw": "currency",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "input": "UpdateUserTripPreferencesInput"
        },

        "types": {
            "UpdateUserTripPreferencesInput": {
                "currency": "Currency",
                "distanceSystem": "DistanceSystem",
                "tripConstraint": "ItineraryConstraint"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    }
};

"HoudiniHash=3a10de72bbaeef35c515d004553f4df9d72b1ccf77b4d8513db7a46428b06cd6";